export const UPDATE_PASSWORD_FIELD = {
  CURRENT: 'update-password-current',
  NEW: 'update-password-new',
  CONFIRM: 'update-password-confirm',
} as const;

export type UpdatePasswordFieldId =
  (typeof UPDATE_PASSWORD_FIELD)[keyof typeof UPDATE_PASSWORD_FIELD];

export interface MobileDialogViewportStyle {
  maxHeight: string;
  top: string;
  transform: string;
}

export interface VisualViewportBox {
  height: number;
  offsetTop: number;
}
